import { useState } from 'react';
import SubscribeSlider from '../components/SubscribeSlider';
import HeroVisual from '../components/HeroVisual';
import SEO from '../components/SEO';
import Logo from '../assets/waybook.png';

export default function HomePage() {
  const [showVideo, setShowVideo] = useState(false);
  const [heroProgress, setHeroProgress] = useState(0);
  const p = (() => {
    const raw = heroProgress;
    if (raw <= 1) return Math.max(0, Math.min(raw, 1));
    return Math.max(0, Math.min(raw / 10, 1));
  })();

  return (
    <div
      className="flex-1 relative overflow-y-visible"
      style={{
        backgroundColor: '#EDF1F3',
        backgroundImage: 'url(/src/assets/bg.jpg)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundAttachment: 'scroll',
        backgroundPosition: 'center top'
      }}
    >
      <SEO
        title="Waybook - Discover Amazing Trips & Travel Creators"
        description="Discover amazing places, connect with fellow travelers, and explore curated trips from top travel creators. Plan your perfect journey with Waybook."
        keywords="travel, trips, travel creators, wanderlust, travel planning, destinations, travel community"
        canonicalUrl="https://www.waybook.me/"
        structuredData={[
          {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Waybook',
            url: 'https://www.waybook.me',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.waybook.me/recommended?q={search_term_string}',
              'query-input': 'required name=search_term_string'
            }
          },
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Waybook',
            url: 'https://www.waybook.me',
            logo: 'https://www.waybook.me/waybook-logo.png',
            description: 'Discover amazing places, connect with fellow travelers, and create unforgettable memories',
            sameAs: [
              'https://www.instagram.com/waybook.me',
              'https://twitter.com/waybookme'
            ]
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'What is Waybook?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Waybook is a travel planning platform that helps you discover amazing places, connect with travel creators, and plan your perfect trip.'
                }
              },
              {
                '@type': 'Question',
                name: 'How can I find travel inspiration on Waybook?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'You can explore curated trips from top travel creators, browse destinations by country, and discover unique travel experiences shared by our community.'
                }
              },
              {
                '@type': 'Question',
                name: 'Is Waybook free to use?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Yes, Waybook is free to use. You can browse trips, discover creators, and plan your travels without any cost.'
                }
              }
            ]
          }
        ]}
      />
      {/* Background visual fills section */}
      <HeroVisual showVideo={showVideo} progress={heroProgress} />

      {/* Hero content over background */}
      <section className="relative z-10 h-full flex items-center py-20 md:py-40">
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <img src={Logo} alt="Waybook Logo" className="mx-auto mb-8 h-20" />
          {/* Single text with gradient color mask (white -> black) */}
          <h1
            className="text-5xl md:text-6xl font-bold mb-6 transition-colors duration-700 ease-out"
            style={{
              color: p === 1 ? 'white' : 'black',
            }}
          >
            Plan Your Perfect Trip
          </h1>
          <p
            className="text-xl mb-12 transition-colors duration-700 ease-out"
            style={{
              color: p === 1 ? 'rgba(255,255,255,0.85)' : 'rgba(0,0,0,0.8)',
            }}
          >
            Discover amazing places, connect with fellow travelers, and create unforgettable memories with Waybook.
          </p>

          {/* Subscribe Form */}
          <div id="subscribe">
            <SubscribeSlider 
              onUnlocked={() => setShowVideo(true)}
              onProgress={(p) => setHeroProgress(p)}
            />
          </div>
        </div>
      </section>
    </div>
  );
}
